import React, { useState, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { Button, LinearProgress } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { AppConfig } from "../../../configs/client-config";
import { useHistory } from "react-router-dom";
import { setEncodeValue, setUserEmail, getEncodValue, getAccessToken } from "../../../utils/oauth";

import parse from "html-react-parser";

const useStyles = makeStyles()((theme) => ({
  errorMsg: {
    color: "red",
    marginTop: 15,
  },
  linearProgress: {
    marginTop: 15,
    marginBottom: 5,
    width: "100%",
  },
}));

function SimpleDialog(props) {
  const { classes } = useStyles();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [fieldError, setFieldError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setEncodeValue(props.encodeValue);
  }, [props]);

  const handleClose = () => {};

  const validateEmail = async () => {
    setFieldError(false);
    setErrorMessage("");
    if (email === "") {
      setFieldError(true);
      setErrorMessage("Please enter your Email address");
    } else {
      setLoading(true);
      const requestURL = AppConfig.baseUrl + AppConfig.validateEmail;

      let data = {
        email: email,
        encodeValue: props.encodeValue,
      };

      // Move to generalized implementation
      try {
        let response = await fetch(requestURL, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + getAccessToken(),
          },
          body: JSON.stringify(data),
        });
        let body = await response.json();
        if (response.status === 400) {
          setErrorMessage(
            "Form Not Found!<br>Contact Us : <a target='_blank' href='mailto:" +
              AppConfig.financeEmail +
              "'>" +
              AppConfig.financeEmail +
              "</a>"
          );
        } else if (response.status === 403) {
          setErrorMessage(
            "The link has expired!<br>Contact Us : <a target='_blank' href='mailto:" +
              AppConfig.financeEmail +
              "'>" +
              AppConfig.financeEmail +
              "</a>"
          );
        } else if (response.status === 404) {
          setErrorMessage(
            "Invalid Email Address!<br>Contact Us : <a target='_blank' href='mailto:" +
              AppConfig.financeEmail +
              "'>" +
              AppConfig.financeEmail +
              "</a>"
          );
          setFieldError(true);
        } else if (response.status === 200) {
          const tradeReferenceEnabled = body.message?.isTradeReferenceEnabled ?? false;
          setUserEmail(email);
          history.push({
            pathname: AppConfig.urls.RESELLER_FORM + "?encodeValue=" + getEncodValue() + "&email=" + email,
            state: { isValid: true, tradeReferenceEnabled },
          });
          window.location.reload();
        } else {
          setErrorMessage("Something went wrong with the server");
          setFieldError(true);
          console.error(body.message);
        }
        setLoading(false);
        return null;
      } catch (error) {
        setErrorMessage("Something went wrong with the server");
        setFieldError(true);
        setLoading(false);
        console.error(error);
        return error;
      }
    }
  };

  const emailHandler = (e) => {
    setEmail(e.target.value);
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth>
        <DialogTitle id="form-dialog-title">User Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>Please enter your email address</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            fullWidth
            onChange={emailHandler}
            error={fieldError}
          />
          {loading && <LinearProgress className={classes.linearProgress} color="secondary" />}
          <Typography variant="body2" className={classes.errorMsg}>
            {parse(errorMessage)}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={validateEmail} color="secondary" size="small">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default function ValidateEmail(props) {
  const handleClose = (value) => {};

  return (
    <div>
      <SimpleDialog open={true} onClose={handleClose} encodeValue={props.match.params.encodeValue} />
    </div>
  );
}
